export const isBrowserSupported = () => {
  // Check if the browser is supported
  const supportsWebWorkers = typeof Worker !== "undefined";
  const supportsServiceWorkers = "serviceWorker" in navigator;

  return supportsWebWorkers && supportsServiceWorkers;
};
